<template>
  <div>
    <el-card class="box-card">
      <el-form :inline="true" label-width="120px" ref="searchQualificat">
        <el-form-item label="市场：">
          <el-select v-model="query.marketId" clearable style='width: 215px;' placeholder="请选择">
            <el-option v-for="(item, index) in $key.common.market" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="付款单号：">
          <el-input v-model.trim="query.paymentCode" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="申请单号：">
          <el-input v-model.trim="query.bizId" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="支付状态：" >
          <el-select v-model="query.tradeStatus" clearable style="width: 217px;">
            <el-option v-for="item in tradeStatusOption" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易类型：" >
          <el-select v-model="query.tradeType" clearable style="width: 217px;">
            <el-option v-for="item in tradeTypeOption" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易方账号：">
          <el-input v-model="query.payerAccNo" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="对方账号：">
          <el-input v-model="query.receiverAccNo" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="账户类型：" >
          <el-select v-model="query.accountType" clearable style="width: 217px;">
            <el-option v-for="item in accountTypeOption" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付日期：">
          <el-date-picker  type="date" clearable placeholder="开始日期" v-model="query.leftCreateDate"></el-date-picker>
          -
          <el-date-picker  type="date" clearable placeholder="结束日期" v-model="query.rightCreateDate"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="retrieve(1)"><i class="fa fa-search"> 查询</i>
          </el-button>
          <el-button type="primary" plain @click="resetQuery"><i class="fa fa-refresh"> 重置</i>
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <!-- <el-row class="m-b-10">
      <el-button @click="toExport" v-if="$store.state.menu.btnList.export" type="primary" :loading="loading">
        <i class="fa fa-download">导出</i>
      </el-button>
    </el-row> -->
    <!-- 导出 -->
    <div class="inqueryResult clearfix">
      <label class="title-line"></label>
      <span class="title">查询结果</span>
      <div style="float: right">
        <span v-if="exportType !== ''">
          <el-button @click="toExport" type="primary" class='btn' :loading="loading">
            确定下载
          </el-button>
          <el-button @click='cancel' class='btn'>
            取消
          </el-button>
        </span>
        <el-select v-else v-model="exportType" style='width: 120px; float: left' clearable placeholder="导出" @change="isChange">
          <el-option v-for="(item, index) in exportTypeOption" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
    </div>
    <el-table ref="zTable" :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" v-if="exportType === '20'">
        <template slot-scope="scope" >
          <div v-if="scope.row.checkedBill">
            <el-checkbox v-model="scope.row.checked1" @change="changeBill(scope.row.checked1, scope.row)"></el-checkbox>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="marketName" align="center" label="市场"></el-table-column>
      <el-table-column prop="paymentCode" align="center" label="付款单号"></el-table-column>
      <el-table-column prop="bizId" align="center" label="申请单号"></el-table-column>
      <el-table-column prop="accountType" align="center" label="账户类型"  :formatter="accountType"></el-table-column>
      <el-table-column prop="tradeType" align="center" label="交易类型" :formatter="transactionType"></el-table-column>
      <el-table-column prop="tradeDesc" align="center" label="交易说明"></el-table-column>
      <el-table-column prop="tradeDirection" align="center" label="交易方向" :formatter="tradeDirection"></el-table-column>
      <el-table-column prop="payerAccNo" align="center" label="交易方账号"></el-table-column>
      <el-table-column prop="payerAccName" align="center" label="交易方账户名"></el-table-column>
      <el-table-column prop="receiverAccNo" align="center" label="对手方账号"></el-table-column>
      <el-table-column prop="receiverAccName" align="center" label="对手方账户名"></el-table-column>
      <el-table-column prop="amount" align="center" label="金额（元）">
        <template slot-scope="scope">
          <span>
            {{ scope.row.amount | thousandMark}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="completeTime" align="center" label="支付时间"></el-table-column>
      <el-table-column prop="tradestatus" align="center" label="支付状态" :formatter="tradeStatusType"></el-table-column>
      <el-table-column prop="channelName" align="center" label="渠道名称"></el-table-column>
      <el-table-column prop="bizDescription" align="center" label="备注"></el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      layout='total, prev, pager, next'
      :current-page.sync="currentPage"
      :total='total'
      @current-change="changePage"
      background>
    </el-pagination>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import api from '@/api'
import { formatTime } from '@/utils/util'
function Query () {
  this.accountType = ''
  this.marketId = ''
  this.paymentCode = ''
  this.tradeType = ''
  this.payerAccNo = ''
  this.tradeStatus = ''
  this.bizId = ''
  this.leftCreateDate = ''
  this.rightCreateDate = ''
}
export default {
  name: '',
  data () {
    return {
      loading: false,
      query: new Query(),

      // 渠道列表
      channelList: [],

      // 导出类型
      exportType: '',
      exportTypeOption: [{
        id: '10',
        name: '全部导出'
      }, {
        id: '20',
        name: '部分导出'
      }],

      // 账户类型
      accountTypeOption: [{
        id: 'SUB_ACCOUNT',
        name: '附属账户'
      }, {
        id: 'GOODS_ACCOUNT',
        name: '货款账户'
      }],

      // 列表数据
      tableData: [],

      // 分页数据
      currentPage: 1,
      total: 0,
      pageSize: 10,

      // 部分下载单编码集合
      paymentCodes: [],
      // 全部下载付款单编码
      billCodes: [],
      json: {},

      // 交易类型
      tradeTypeOption: [{
        id: '50',
        name: '充值'
      }, {
        id: '30',
        name: '转账'
      }, {
        id: '20',
        name: '提现'
      }, {
        id: '10',
        name: '代付'
      }, {
        id: '40',
        name: '付款'
      }],

      // 交易状态
      tradeStatusOption: [{
        id: '10',
        name: '处理中'
      }, {
        id: '20',
        name: '交易成功'
      }, {
        id: '30',
        name: '交易失败'
      }, {
        id: '40',
        name: '订单不存在'
      }]
    }
  },
  created () {
    this.retrieve(1, 10)
  },
  methods: {
    // 选择
    handleSelectionChange (val) {
      if (val.length > 0) {
        this.tableData.forEach((item, index) => {
          this.$set(this.tableData[index], 'checked1', true)
          if (item.receiptFlag && item.tradeStatus === '20') {
            this.$set(this.tableData[index], 'checkedBill', true)
            this.json[index + ''] = item.paymentCode
          } else {
            this.$set(this.tableData[index], 'checkedBill', false)
          }
        })
      } else {
        this.tableData.forEach((item, index) => {
          this.$set(this.tableData[index], 'checked1', false)
          if (item.receiptFlag && item.tradeStatus === '20') {
            this.$set(this.tableData[index], 'checkedBill', true)
          } else {
            this.$set(this.tableData[index], 'checkedBill', false)
          }
        })
      }
    },

    // 选择导出类型
    isChange (v) {
      this.exportType = v
    },

    // 取消下载
    cancel () {
      this.exportType = ''
    },

    changeBill (v, d) {
      if (v === false) {
        this.json[d.index + ''] = ''
      } else {
        this.json[d.index + ''] = d.paymentCode
      }
    },

    // 导出
    toExport () {
      if (this.exportType === '10') {
        // 全部导出
        let param = this.query
        this.loading = true
        api.myAccount.downloadReceipt(param).then((res) => {
          this.$utils.getExcelFile(this, api.billExport, res.data, () => {
            this.loading = false
          })
        }).catch((err) => {
          this.loading = false
          this.$message.error(err)
        })
      } else {
        // 部分导出
        let formJSON = []
        for (let item in this.json) {
          formJSON.push(this.json[item])
        }
        this.loading = true
        this.$utils.getExcelFile(this, api.billExport, formJSON, () => {
          this.loading = false
        })
      }
    },

    // 选择市场
    // selectMarketChange (val) {
    //   this.query.channelCode = ''
    //   api.common.getBankChannel({
    //     marketId: val
    //   }).then((res) => {
    //     this.channelList = res.data
    //   })
    // },

    // 获取列表数据
    retrieve (currentNo, pageSize) {
      this.json = {}
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentNo = currentNo || this.currentNo || 1
      let param = Object.assign({}, this.query, {
        currentNo: this.currentNo,
        pageSize: this.pageSize,
        leftCreateDate: formatTime(this, this.query.leftCreateDate),
        rightCreateDate: formatTime(this, this.query.rightCreateDate, 1),
        payerSysAccount: Cookie.getJSON('AppUserInfo').account,
      })
      api.myAccount.billList(param).then((data) => {
        this.tableData = data.data.rows
        this.tableData.forEach((item, index) => {
          // 待支付、支付中、支付失败
          item.index = index
          this.$set(this.tableData[index], 'checked1', false)
          if (item.receiptFlag && item.tradeStatus === '20') {
            this.$set(this.tableData[index], 'checkedBill', true)
          } else {
            this.$set(this.tableData[index], 'checkedBill', false)
          }
        })
        this.total = data.data.totalElements
      })
    },

    // 账户类型
    accountType (row) {
      if (row.accountType === 'SUB_ACCOUNT') {
        return '附属账户'
      } else if (row.accountType === 'DOODS_ACCOUNT') {
        return '货款账户'
      } else {
        return '/'
      }
    },

    // 交易类型
    transactionType (row) {
      if (row.tradeType === '10') {
        return '代付'
      } else if (row.tradeType === '20') {
        return '提现'
      } else if (row.tradeType === '30') {
        return '转账'
      } else if (row.tradeType === '40') {
        return '付款'
      } else if (row.tradeType === '50') {
        return '充值'
      } else if (row.tradeType === '60') {
        return '解冻'
      } else {
        return '/'
      }
    },

    // 业务类型
    settlebusinesstype (row) {
      if (row.settleBusinessType === '10') {
        return '代付到卡'
      } else if (row.settleBusinessType === '102') {
        return '代付到余额'
      } else if (row.settleBusinessType === '201') {
        return '采购代付'
      } else if (row.settleBusinessType === '202') {
        return '货款入金附属户转卡'
      } else if (row.settleBusinessType === '203') {
        return '附属户提现'
      } else if (row.settleBusinessType === '301') {
        return '附属户转账'
      } else if (row.settleBusinessType === '302') {
        return '预售放款'
      } else if (row.settleBusinessType === '303') {
        return '预售还款'
      } else if (row.settleBusinessType === '304') {
        return '货款出金附属户转附属户'
      } else if (row.settleBusinessType === '305') {
        return '诚意金出金附属户转附属户'
      } else if (row.settleBusinessType === '306') {
        return '诚意金入金附属户转附属户'
      } else if (row.settleBusinessType === '307') {
        return '货款入金附属户转附属户'
      } else if (row.settleBusinessType === '401') {
        return '货款出金卡转附属户'
      } else if (row.settleBusinessType === '402') {
        return '附属户支付'
      } else if (row.settleBusinessType === '403') {
        return '分账支付'
      } else if (row.settleBusinessType === '501') {
        return '附属户线上充值'
      } else if (row.settleBusinessType === '502') {
        return '附属户线下充值'
      } else if (row.settleBusinessType === '503') {
        return '附属户退汇入金'
      } else if (row.settleBusinessType === '601') {
        return '众邦附属户余额冻结'
      } else if (row.settleBusinessType === '602') {
        return '众邦附属户余额解'
      } else {
        return '/'
      }
    },

    // 支付状态
    tradeStatusType (row) {
      if (row.tradeStatus === '10') {
        return '处理中'
      } else if (row.tradeStatus === '20') {
        return '交易成功'
      } else if (row.tradeStatus === '30') {
        return '交易失败'
      } else if (row.tradeStatus === '40') {
        return '订单不存在'
      } else {
        return '/'
      }
    },

    // 交易方向
    tradeDirection (row) {
      if (row.tradeDirection === 'out') {
        return '出金'
      } else if (row.tradeDirection === 'in') {
        return '入金'
      } else {
        return '/'
      }
    },

    // 金额
    amount (row) {
      var f1 = parseFloat(row.amount)
      if (isNaN(f1)) {
        return false
      }
      var f2 = Math.round(row.amount * 100) / 100
      var s = f2.toString()
      var rs = s.indexOf('.')
      if (rs < 0) {
        rs = s.length
        s += '.'
      }
      while (s.length <= rs + 2) {
        s += '0'
      }
      return '+' + s
    },

    // 重置
    resetQuery () {
      this.query = new Query()
      this.retrieve(1)
    },

    // 导出
    // toExport () {
    //   let param = this.query
    //   this.loading = true
    //   this.$utils.getExcelFile(this, this.api.billExport, param, (data) => {
    //     this.loading = false
    //   })
    // },

    // 分页
    changePage (page) {
      this.retrieve(page)
    },
  }
}
</script>
<style lang="scss" scoped>
  .pagination {
    margin: 20px 0 20px 0;
    float: right;
  }
  .inqueryResult{
    margin-top: 15px;
    margin-bottom: 15px;
    height: 32px;
    line-height: 32px;
    .title-line {
      width:4px;
      height:14px;
      background-color:#f8bd47;
      display:inline-block
    }
    .title {
      margin-left: 10px;
      font-size: 16px;
      font-weight: 600;
      color: #161616;
    }
    .export {
      float: right;
      background-color: #FAFAFA;
      color: #999999;
      border-color: #979797;
      height: 32px;
      padding: 0 20px;
      font-size: 15px;
      border-radius: 4px;
      width: 111px;
      i {
        padding-right: 5px;
      }
      ::v-deep span {
        position: relative;
        left: -8px;
      }
    }
    .export:active,
    .export:hover {
      background-color: #c1c1c1;
      color: white
    }
  }
</style>
